var valuePropType = {exports: {}};

export { valuePropType as __module };
